import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { NTA_COLORS } from '../constants';
import { ntaPageCss } from '../typography';

const NUMBER_PAD_ROWS = [
  ['1', '2', '3', '-'],
  ['4', '5', '6', '.'],
  ['7', '8', '9', '0']
];

const Pad = styled.div`
  display: flex;
  flex-direction: column;
  width: 197px;
  ${ntaPageCss}
`;

const PadRow = styled.div`
  display: flex;
  margin-bottom: -1px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const PadKey = styled.button`
  width: 50px;
  height: 50px;
  margin-right: -1px;
  padding: 0;
  border: 1px solid ${NTA_COLORS.numberPadKeyBorder};
  background: ${NTA_COLORS.numberPadKeyBg};
  color: ${NTA_COLORS.textPrimary};
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  &:focus-visible {
    outline: 2px solid ${NTA_COLORS.accentBlue};
    outline-offset: -2px;
    z-index: 1;
  }

  ${({ $roundTopLeft }) => $roundTopLeft && 'border-top-left-radius: 4px;'}
  ${({ $roundTopRight }) => $roundTopRight && 'border-top-right-radius: 4px;'}
`;

const BackspaceKey = styled.button`
  width: 197px;
  height: 50px;
  margin-top: -1px;
  padding: 0;
  border: 1px solid ${NTA_COLORS.numberPadKeyBorder};
  border-radius: 0 0 4px 4px;
  background: ${NTA_COLORS.numberPadKeyBg};
  color: ${NTA_COLORS.textPrimary};
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  &:focus-visible {
    outline: 2px solid ${NTA_COLORS.accentBlue};
    outline-offset: -2px;
  }
`;

const getKeyAriaLabel = (key) => {
  if (key === '-') return 'Minus';
  if (key === '.') return 'Decimal';
  return key;
};

const NtaNumberPad = ({ disabled, onKeyPress, onBackspace }) => (
  <Pad role="group" aria-label="Number pad">
    {NUMBER_PAD_ROWS.map((row, rowIndex) => (
      <PadRow key={row.join('-')}>
        {row.map((key, keyIndex) => (
          <PadKey
            key={key}
            type="button"
            disabled={disabled}
            $roundTopLeft={rowIndex === 0 && keyIndex === 0}
            $roundTopRight={rowIndex === 0 && keyIndex === row.length - 1}
            onClick={() => onKeyPress(key)}
            aria-label={getKeyAriaLabel(key)}
          >
            {key}
          </PadKey>
        ))}
      </PadRow>
    ))}
    <BackspaceKey
      type="button"
      disabled={disabled}
      onClick={onBackspace}
      aria-label="Backspace"
    >
      Backspace
    </BackspaceKey>
  </Pad>
);

NtaNumberPad.propTypes = {
  disabled: PropTypes.bool,
  onKeyPress: PropTypes.func.isRequired,
  onBackspace: PropTypes.func.isRequired
};

export default NtaNumberPad;
